export default function buildParameters(params) {
  const urlParams = new URLSearchParams(window.location.search);

  let firstValueSet = false;
  const linkArray = [];
  Object.keys(params).forEach(paramKey => {
    const paramValue = params[paramKey];
    const value = urlParams.has(paramKey) ? urlParams.get(paramKey) : paramValue;

    const questionMark = firstValueSet ? '' : '?';
    firstValueSet = true;
    if (paramValue) {
      linkArray.push(`${questionMark}${paramKey}=${value}`);
    }
  });
  return linkArray.join('&');
}
